const hostsByNodeEnv = {
  production: '',
  development: 'http://int.much-warehouse-creator.local', //'http://localhost:11040',
  test: 'http://int.much-warehouse-creator.local',
};
const host = hostsByNodeEnv[process.env.NODE_ENV];
const networkConf = {
  baseURL: host,
  timeout: 60000,
};
export default networkConf;
